module.exports = __webpack_public_path__ + "img/COMBO RADIO 2 RED.9f753d3.svg";